/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var lang_1 = require('../facade/lang');
var exceptions_1 = require('../facade/exceptions');
var view_utils_1 = require('./view_utils');
var ComponentRef = (function() {
  function ComponentRef() {}
  Object.defineProperty(ComponentRef.prototype, "location", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentRef.prototype, "injector", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentRef.prototype, "instance", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ComponentRef.prototype, "hostView", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ComponentRef.prototype, "changeDetectorRef", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentRef.prototype, "componentType", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  return ComponentRef;
}());
exports.ComponentRef = ComponentRef;
var ComponentRef_ = (function(_super) {
  __extends(ComponentRef_, _super);
  function ComponentRef_(_hostElement, _componentType) {
    _super.call(this);
    this._hostElement = _hostElement;
    this._componentType = _componentType;
  }
  Object.defineProperty(ComponentRef_.prototype, "location", {
    get: function() {
      return this._hostElement.elementRef;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentRef_.prototype, "injector", {
    get: function() {
      return this._hostElement.injector;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ComponentRef_.prototype, "instance", {
    get: function() {
      return this._hostElement.component;
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ComponentRef_.prototype, "hostView", {
    get: function() {
      return this._hostElement.parentView.ref;
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ComponentRef_.prototype, "changeDetectorRef", {
    get: function() {
      return this._hostElement.parentView.ref;
    },
    enumerable: true,
    configurable: true
  });
  ;
  Object.defineProperty(ComponentRef_.prototype, "componentType", {
    get: function() {
      return this._componentType;
    },
    enumerable: true,
    configurable: true
  });
  ComponentRef_.prototype.destroy = function() {
    this._hostElement.parentView.destroy();
  };
  ComponentRef_.prototype.onDestroy = function(callback) {
    this.hostView.onDestroy(callback);
  };
  return ComponentRef_;
}(ComponentRef));
exports.ComponentRef_ = ComponentRef_;
var EMPTY_CONTEXT = new Object();
var ComponentFactory = (function() {
  function ComponentFactory(selector, _viewFactory, _componentType) {
    this.selector = selector;
    this._viewFactory = _viewFactory;
    this._componentType = _componentType;
  }
  Object.defineProperty(ComponentFactory.prototype, "componentType", {
    get: function() {
      return this._componentType;
    },
    enumerable: true,
    configurable: true
  });
  ComponentFactory.prototype.create = function(injector, projectableNodes, rootSelectorOrNode) {
    if (projectableNodes === void 0) {
      projectableNodes = null;
    }
    if (rootSelectorOrNode === void 0) {
      rootSelectorOrNode = null;
    }
    var vu = injector.get(view_utils_1.ViewUtils);
    if (lang_1.isBlank(projectableNodes)) {
      projectableNodes = [];
    }
    var hostView = this._viewFactory(vu, injector, null);
    var hostElement = hostView.create(EMPTY_CONTEXT, projectableNodes, rootSelectorOrNode);
    return new ComponentRef_(hostElement, this._componentType);
  };
  return ComponentFactory;
}());
exports.ComponentFactory = ComponentFactory;
